import { TFunction } from "i18next";
import { FilterValue, Row } from "react-table";
import { FormatDateString } from "./FormatDate";

export function filterDates<T extends object>(
  rows: Array<Row<T>>,
  id: Array<string>,
  filterValue: FilterValue,
  t: TFunction
) {
  return rows.filter((row) => {
    const rowValue = FormatDateString(row.values[id[0]], t);
    return rowValue !== undefined
      ? String(rowValue)
          .toLowerCase()
          .includes(String(filterValue).toLowerCase())
      : true;
  });
}
